import React from "react";
import { Link } from "react-router-dom";

const ContentImageAndCardSection = ({
  title,
  subtitle,
  listItems = [],
  cardBtnText,
  cardBtnLink,
  image,
  imageClassName,
  reverse = false,
  tickIcon
}) => {
  const containerStyle = {
    display: "flex",
    flexDirection: reverse ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "30px",
    padding: "40px 0",
    flexWrap: "wrap"
  };

  const cardStyle = {
    backgroundColor: "#F6FFF8",
    borderRadius: "24px",
    padding: "25px",
    flex: "1",
    minWidth: "300px",
    border: "1px solid #E4F1E7"
  };

  const listItemStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px",
    marginBottom: "24px"
  };

  return (
    <div style={containerStyle}>
      {/* LEFT CONTENT CARD */}
      <div style={cardStyle}>
        <p className="FS20FW500 fw-600">{title}</p>
        <p style={{color:"#686868"}} className="FS14FW600">{subtitle}</p>

        <div style={{ marginBottom: "40px" }}>
          {listItems.map((item, index) => (
            <div key={index} style={listItemStyle}>
              {tickIcon && <img src={tickIcon} alt="tick" className="FS16FW500" />}
              <div>
                <div className="FS16FW500 fw-600" >{item.title}</div>
                <div style={{color:"#686868"}} className="FS12">{item.description}</div>
              </div>
            </div>
          ))}
        </div>

        {cardBtnText && (
          <Link 
            to={cardBtnLink || "#"} 
            style={{
              backgroundColor: "#E9ECEF",
              borderRadius: "16px",
              padding: "12px 34px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textDecoration:"none"
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#DEE2E6"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#E9ECEF"}
          >
            <span style={{
              color: "#182A4F",
              fontWeight: "700",
              fontSize: "16px",
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}>
              {cardBtnText}
            </span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#182A4F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        )}
      </div>

      {/* RIGHT IMAGE */}
       {image && (
        <div className="col-lg-6 col-md-12 cis-image-col">
          <img className={`cis-image ${imageClassName || ""}`} src={image} alt={"LA"} />
        </div>
      )}
    </div>
  );
};

export default ContentImageAndCardSection;

